<template>
  <div class="common">
    <!-- 搜索表单 -->
    <search-form :formConfig="formConfig" :source="searchData" @handleSearch="handleSearch" @search="search">
      <template slot="btns">
        <a-button v-if="btns.indexOf('onPay') > -1" :disabled="selectedRows.length == 0" @click="onPay()"
          class="search-btn-item btn-blue-line">付款</a-button>
        <a-button v-if="btns.indexOf('onPayApprove') > -1" :disabled="selectedRows.length == 0" @click="onPayApprove()"
          class="search-btn-item btn-blue-line">付款凭证审批</a-button>
           <a-button @click="onExport" class="search-btn-item" type="primary">导出</a-button>
      </template>
    </search-form>

    <div class="table-common common-scroll">
      <div class="table-check-bar" v-if="selectedRows.length">
        已选择：
        <span class="text-color-blue">{{ selectedRows.length }} 条</span>
        祺信面额：
        <span class="text-color-orange">{{ totalPayable(selectedRows) | splitK }} 元</span>
      </div>
      <a-table size="middle" :columns="columns" :row-key="(record, index) => record.id" :data-source="tableData"
        :pagination="pagination" :loading="loading" @change="handleTableChange" bordered :scroll="{}"
        :locale="{ emptyText: '暂无数据' }" :row-selection="{
          selectedRowKeys: selectedRowKeys,
          selectedRows: selectedRows,
          onChange: onTableChange
        }">
        <template slot="guarantorName" slot-scope="text,record">
          <span v-if="record.guarantorName">
            {{ record.guarantorName }}
          </span>
          <span v-else>--</span>
        </template>
        <template slot="holderName" slot-scope="text, record">
          <span :title="record.holderName || record.rcPtyNm">{{ record.holderName || record.rcPtyNm }}</span>
        </template>
        <template slot="gldAmt" slot-scope="text">{{ text | splitK }}</template>
        <template slot="exDay" slot-scope="text">
          {{
            text | dateFormat("YYYY-mm-dd")
          }}
        </template>
        <template slot="residueDays" slot-scope="text, record">
          {{
            getDaysFormNow(record.exDay)
          }}
        </template>
        <template slot="toRepyAmt" slot-scope="text, record">
          {{
            totaltoRepyGldInt(record)
            ? totaltoRepyAmt(record) + "+" + totaltoRepyGldInt(record)
            : totaltoRepyAmt(record)
          }}
        </template>
        <template slot="canBeModified" slot-scope="text">{{
          text | gbCbmTrans
        }}</template>
        <template slot="odueCd" slot-scope="text">{{
          text == 1 ? "是" : "否"
        }}</template>
        <template slot="pymAmt" slot-scope="text, record">
          {{ record.pymAmt | splitK }}
        </template>
        <template slot="openType" slot-scope="text">
          {{ text == 0 ? "无" : "有" }}
        </template>
        <template slot="operation" slot-scope="text, record">
          <a @click="toPageDetail(record)">详情</a>
          <a v-if="record.isNotice == 1" @click="toPayNotice(record)">
            付款通知
          </a>
          <a @click="uploadVoucher(record, 'create')" v-if="!record.uploadVoucher">
            上传凭证
          </a>
          <a @click="uploadVoucher(record, 'detail')" v-if="record.uploadVoucher">
            查看凭证
          </a>
          <a class="text-color-red" @click="deleteVoucher(record)" v-if="record.uploadVoucher">
            删除凭证
          </a>
        </template>
      </a-table>
      <div v-show="tabType === 'goldchecks'" :class="{
        'table-total': pagination.total > 0,
        'table-total-none': pagination.total == 0
      }">
        共有记录：
        <span class="text-color-blue">{{ pagination.total }} 条</span>待付余额：
        <span class="text-color-orange">{{ totalPayable(tableData) | splitK }} 元</span>
      </div>
    </div>
    <payNotice ref="payNotice" :info.sync="curItem" />
    <onpayModal ref="onpayModal" :info.sync="selectedRows" @success="refresh" />
    <uploadVoucherDialog ref="uploadVoucherDialog" @success="refresh" />
    <voucherApproveDialog ref="voucherApproveDialog" @success="refresh" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { findGoldEstbOrRcPtyOrPypt,pagingGldInfListExport } from "@/api/gold.js";
import {
  pagingGldInfList,
  checkGldInf,
  isShowPymNoticeFile
} from "@/api/buyrPym.js";
import { deletePayVoucher } from "@/api/pay.js"
import payNotice from "./pay-notice";
import onpayModal from "./onpay-modal";
import uploadVoucherDialog from "./uploadVoucherDialog.vue"
import voucherApproveDialog from "./voucherApproveDialog.vue"
export default {
  props: {
    tabType: {
      type: [String, Number]
    },
    status: {
      type: [String, Number]
    },
    odueCd: {
      type: [String, Number]
    },
    isShow: {
      type: Boolean
    },
    btns: {
      type: [Array],
      default: () => {
        return [];
      }
    }
  },
  name: "gold-checks",
  components: {
    payNotice,
    onpayModal,
    uploadVoucherDialog,
    voucherApproveDialog
  },
  data() {
    return {
      searchData: {
        estbDay: [],
        gldId: "",
        exDay: [],
        receiver: "",
        canBeModified: [],
        tenantId: ""
      },
      formConfig: [
        {
          prop: "exDay",
          type: "dateRange",
          label: "到期日期"
        },
        {
          prop: "gldId",
          type: "input",
          label: "祺信编号"
        },
        {
          prop: "receiver",
          type: "selectSearch",
          label: "接收方",
          option: [],
          searchSource: true,
          headNameFirst: "开立方名称",
          headNameSecond: "社会信用代码",
          valuePorp: "orgCode",
          valuePorpReal: "cstId",
          labelPorp: "cstNm",
          searchHandle: "handleSearch"
        },
        {
          prop: "canBeModified",
          type: "select",
          label: "变更状态",
          option: this.dict.modifiedStatus,
          mode: "multiple",
          defaultProps: {
            value: "value",
            label: "name"
          }
        },
        {
          prop: "odueCd",
          type: "select",
          label: "是否逾期",
          option: this.dict.yesOrNo,
          defaultProps: {
            value: "value",
            label: "name"
          }
        }
      ],
      columns: [
        {
          title: "祺信编号",
          dataIndex: "gldId",
          ellipsis: true,
          width: 160,
          sorter: true
        },
        {
          title: " 担保方",
          dataIndex: "guarantorName",
          scopedSlots: { customRender: "guarantorName" },
        },
        {
          title: "接收方",
          dataIndex: "rcPtyNm",
          width: 180,
          ellipsis: true,
          sorter: true
        },
        {
          title: "持有方",
          dataIndex: "holderName",
          width: 180,
          ellipsis: true,
          scopedSlots: { customRender: "holderName" }
        },
        {
          title: "祺信面额(元)",
          dataIndex: "gldAmt",
          sorter: true,
          width: 140,
          scopedSlots: { customRender: "gldAmt" }
        },
        {
          title: "待付余额(元)",
          dataIndex: "toRepyAmt",
          sorter: true,
          width: 140,
          scopedSlots: { customRender: "toRepyAmt" }
        },
        {
          title: "付款金额(元)",
          dataIndex: "pymAmt",
          sorter: true,
          width: 140,
          scopedSlots: { customRender: "pymAmt" }
        },
        {
          title: "到期日期",
          sorter: true,
          width: 100,
          dataIndex: "exDay",
          scopedSlots: { customRender: "exDay" }
        },
        {
          title: "剩余天数",
          sorter: true,
          width: 100,
          dataIndex: "residueDays",
          scopedSlots: { customRender: "residueDays" }
        },
        // {
        // title: "保理商",
        // dataIndex: "tenantName",
        // },
        {
          title: "变更状态",
          dataIndex: "canBeModified",
          width: 100,
          scopedSlots: { customRender: "canBeModified" }
        },
        {
          title: "是否逾期",
          dataIndex: "odueCd",
          width: 100,
          scopedSlots: { customRender: "odueCd" }
        },
        {
          title: "有无发票",
          dataIndex: "openType",
          width: 80,
          scopedSlots: { customRender: "openType" },
        },
        {
          title: "操作",
          dataIndex: "operation",
          width: 220,
          scopedSlots: { customRender: "operation" }
        }
      ],
      tableData: [],
      pagination: {
        pageSize: 10,
        current: 1,
        sortField: "exDay",
        sortOrder: "ascend",
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
        showTotal: total => {
          return `共 ${total} 条`;
        }
      },
      loading: false,
      selectedRows: [],
      selectedRowKeys: [],
      curItem: null
    };
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"
    })
  },
  mounted() {
    this.getTableData();
    if (!this.isShow) { // this.$auth('admin')这个方法是我判断权限得，返回值为true 或者false
      this.columns = this.columns.filter(item => item.dataIndex !== 'guarantorName') // 控制客户经理列是否展示
    }

  },
  methods: {
     onExport() {
       let params = {};
      const cstIds = this.userObj.cstIds.join(",");
      let orderKey = this.pagination.sortField;
      if (orderKey == "residueDays") {
        orderKey = 'exDay';
      }
      if (orderKey == "pymAmt") {
        orderKey = 'gldAmt';
      }

      params = {
        orderBy: this.pagination.sortField
          ? `${orderKey} ${this.pagination.sortOrder == "ascend" ? "asc" : "desc"
          }`
          : "",
        gldId: this.searchData.gldId,
        rcPty: this.searchData.receiver.key,
        canBeModified: this.searchData.canBeModified && this.searchData.canBeModified.length > 0 ? this.searchData.canBeModified.join(",") : null,
        exBgdt: this.searchData.exDay[0],
        exExdt: this.searchData.exDay[1],
        odueCd: this.odueCd || this.searchData.odueCd,
        status: this.status
      };
      pagingGldInfListExport(params).then(res => {
        this.utils.fileDownload(res, `查询记录_${new Date().getTime()}.xls`);
      }).catch(e => {
        this.$message.error("导出失败");
      })
    },
    handleSearch(value, data) {
      this.getDataList(value);
    },
    getDataList(value) {
      //下拉筛选
      const cstIds = this.userObj.cstIds.join(",");
      findGoldEstbOrRcPtyOrPypt({
        pageNum: 1,
        pageSize: 10,
        gldStCds: this.gldStCds,
        oriGldId: this.oriGldId,
        estb: cstIds,
        pypt: cstIds,
        queryType: 0,
        cstIds: cstIds,
        customerName:value
      })
        .then(res => {
          this.formConfig[2].option = res.data.grid.list;
        })
        .catch(err => {
          console.log(err);
        });
    },
    search(data) {
      this.searchData = data || this.searchData;
      this.getTableData();
    },
    totalPayable(list) {
      return list.reduce((acc, rec) => {
        return acc + (+rec.toRepyAmt || 0);
      }, 0);
    },
    onTableChange(selectedRows, data) {
      //表格选择回调
      this.selectedRowKeys = selectedRows;
      this.selectedRows = this.tableData.filter(
        item => selectedRows.indexOf(item.id) > -1
      );
      this.selectedRows.forEach((item, index) => {
        this.selectedRows[index].thsPymAmt = item.pymAmt;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      //表格排序回调
      this.pagination = {
        current: pagination.current,
        pageSize: pagination.pageSize,
        sortField: sorter.field,
        sortOrder: sorter.order,
        total: this.pagination.total || 0
      };
      this.getTableData();
    },
    getTableData() {
      let params = {};
      const cstIds = this.userObj.cstIds.join(",");
      let orderKey = this.pagination.sortField;
      if (orderKey == "residueDays") {
        orderKey = 'exDay';
      }
      if (orderKey == "pymAmt") {
        orderKey = 'gldAmt';
      }

      params = {
        orderBy: this.pagination.sortField
          ? `${orderKey} ${this.pagination.sortOrder == "ascend" ? "asc" : "desc"
          }`
          : "",
        gldId: this.searchData.gldId,
        rcPty: this.searchData.receiver.key,
        canBeModified: this.searchData.canBeModified && this.searchData.canBeModified.length > 0 ? this.searchData.canBeModified.join(",") : null,
        exBgdt: this.searchData.exDay[0],
        exExdt: this.searchData.exDay[1],
        odueCd: this.odueCd || this.searchData.odueCd,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        status: this.status
      };
      this.loading = true;
      pagingGldInfList(params)
        .then(res => {
          this.selectedRows = [];
          this.selectedRowKeys = [];
          this.pagination.total = res.data.grid.total;
          this.tableData = res.data.grid.list;
          this.loading = false;
          // this.renderTableAllPage();
          this.isShowPymNoticeFile();
        })
        .catch(err => {
          this.loading = false;
        });
    },
    isShowPymNoticeFile() {
      const params = [];
      let data = this.tableData;
      if (data.length == 0) {
        return;
      }
      data.forEach(item => {
        params.push({ gldId: item.gldId, tenantId: item.tenantId });
      });
      isShowPymNoticeFile({ gldListStr: JSON.stringify(params) }).then(res => {
        let resData = res.data;
        let list = data.map(i => i.gldId + "_" + i.tenantId);
        for (let k = 0; k < resData.length; k++) {
          let k_index = list.indexOf(
            resData[k].gldId + "_" + resData[k].tenantId
          );
          if (k_index > -1) {
            this.$set(this.tableData, k_index, {
              ...this.tableData[k_index],
              isNotice: resData[k].isNotice
            });
          }
        }
      });
    },
    toPageDetail(data) {
      let way = "buyer";
      this.MENUAPI.goToOneTab({
        path: "bill-payment/payment/detail/" + way + "/" + data.gldId + "/" + 3,
        query: {
          fromPath: "bill-payment/payment",
          detailFrom:'payment'
        }
      });
    },
    toPayNotice(data) {
      this.curItem = data;
      this.$refs.payNotice.open();
    },
    totaltoRepyAmt(rows) {
      return [rows].reduce((acc, rec) => {
        return this.utils.splitK(acc + (rec.toRepyAmt || 0));
      }, 0);
    },
    totaltoRepyGldInt(rows) {
      return [rows].reduce((acc, rec) => {
        return this.utils.splitK(acc + (rec.toRepyGldInt || 0));
      }, 0);
    },
    totalPymAmt(rows) {
      return [rows].reduce((acc, rec) => {
        return this.utils.splitK(acc + (rec.pymAmt || 0));
      }, 0);
    },
    onPay() {
      let isVoucher = false;
      for (const item of this.selectedRows) {
        if (item.uploadVoucher) {
          isVoucher = true;
        }
        if (+item.pymAmt === 0) {
          this.$message.error("所勾选祺信的付款金额均需大于0");
          return;
        }
        if (+item.pymAmt > (Math.round(item.toRepyAmt * 100) + Math.round(item.toRepyGldInt * 100)) / 100) {
          this.$message.error("所勾选祺信的付款金额均不可大于待付余额");
          return;
        }
      }
      let self = this;
      if (isVoucher) {
        this.$confirm({
          title: '祺信兑付',
          content: "您所选择的祺信已上传付款凭证，是否继续付款？",
          onOk() {
            checkGldInf(
              {
                gldListStr: JSON.stringify(self.selectedRows)
              },
              true
            ).then(res => {
              self.$refs.onpayModal.open();
            });
          },
          onCancel() { }
        })
      } else {
        checkGldInf(
          {
            gldListStr: JSON.stringify(self.selectedRows)
          },
          true
        ).then(res => {
          self.$refs.onpayModal.open();
        });
      }
    },
    // 付款凭证审批
    onPayApprove() {
      for (const item of this.selectedRows) {
        if (!item.uploadVoucher) {
          this.$message.error("所勾选的数据未上传凭证，请上传付款凭证后提交审批");
          return;
        }
      }
      this.$refs.voucherApproveDialog.open({
        selectedRows: this.selectedRows
      })
    },
    // 打开上传凭证的弹窗
    uploadVoucher(record, type) {
      this.$refs.uploadVoucherDialog.open({
        record: record,
        type
      })
    },
    // 删除凭证
    deleteVoucher(record) {
      const self = this;
      this.$confirm({
        title: '提示',
        content: "是否删除该记录的凭证？",
        onOk() {
          deletePayVoucher(record.gldId, { time: new Date().getTime() }).then(res => {
            self.$message.success("删除成功");
            self.refresh();
          })
        },
        onCancel() { }
      })
    },
    // 计算距离到期日还有几天
    getDaysFormNow(date) {
      let a_val = window.sessionStorage.getItem("systemDate") || "";
      let a = this.moment(a_val.replace(/-/g, '/') || "");
      let b = this.moment(date.replace(/-/g, '/'));
      let res = b.diff(a, 'days');
      if (+res >= 0) {
        return res;
      }
    },
    refresh() {
      this.selectedRows = [];
      this.selectedRowKeys = [];
      this.$store.dispatch("home/getMessageCount");
      this.search();
    }
  },
  activated() { }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/bill-payment/gold-checks.vue